module.exports = __webpack_public_path__ + "img/ios-internet.011152a6.svg";